export enum OrderDirectionEnum {
    ASC = 'asc',
    DESC = 'desc',
}
